var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","ripple":false},on:{"click":function($event){return _vm.$function.movePage(_vm.$pages.HOME.name)}}},[_c('v-icon',{attrs:{"color":_vm.additionalBtnColor}},[_vm._v(" mdi-home ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }